import { styled, Box } from '@mui/material';

import { variables } from 'shared/styles';

export const StyledTransferOwnershipForm = styled(Box)`
  max-width: 54.6rem;

  .MuiTypography-root {
    color: ${variables.palette.on_surface_variant};
  }
`;
